import React from 'react';
import {
  Item,
  Tab,
  Table,
} from 'semantic-ui-react';

export const PaneRenter = (props) => {
  const {
    coRenter,
    renter,
  } = props;

  const renterReviewTable = (person) => {
    const references = person.references.map((r, i) => {
      return (
        <React.Fragment key={i}>
          <Table.Row>
            <Table.Cell content={<b>Reference {i + 1}</b>} colSpan={2} icon="user" />
          </Table.Row>
          <Table.Row>
            <Table.Cell content="Name" />
            <Table.Cell
              content={
                r.first_name && r.last_name
                  ? `${r.first_name} ${r.last_name}`
                  : 'n/a'
              }
            />
          </Table.Row>
          <Table.Row>
            <Table.Cell content="Phone" />
            <Table.Cell content={r.phone} />
          </Table.Row>
          <Table.Row>
            <Table.Cell content="Email" />
            <Table.Cell content={r.email} />
          </Table.Row>
          <Table.Row>
            <Table.Cell content="Relationship to Renter" />
            <Table.Cell content={r.relationship} />
          </Table.Row>
        </React.Fragment>
      );
    });

    return (
      <Item>
        <Item.Content>
          <Item.Header content={`${person.first_name} ${person.last_name} ${person.co_renter ? ' (Co-Renter)' : ' (Renter)'}`} />
          <Item.Description>
            <Table celled compact striped color="blue">
              <Table.Body>
                <Table.Row>
                  <Table.Cell content={<b>Renter Info</b>} icon="address card" colSpan={2} />
                </Table.Row>
                <Table.Row>
                  <Table.Cell content="Address" />
                  <Table.Cell content={
                    `${person.address_1} ${person.address_2 ? person.address_2 : ''} ${person.city}, ${person.state} ${person.zip}`
                  }/>
                </Table.Row>
                <Table.Row>
                  <Table.Cell content="Birthdate" />
                  <Table.Cell content={person.birthdate_formatted} />
                </Table.Row>
                <Table.Row>
                  <Table.Cell content="Email" />
                  <Table.Cell content={person.email} />
                </Table.Row>
                <Table.Row>
                  <Table.Cell content="Contact Phone" />
                  <Table.Cell content={person.home_phone} />
                </Table.Row>
                <Table.Row>
                  <Table.Cell content="Driver's License" />
                  <Table.Cell content={person.drivers_license ? person.drivers_license : ''} />
                </Table.Row>
                <Table.Row>
                  <Table.Cell content={<b>Employer Info</b>} icon="building" colSpan={2} />
                </Table.Row>
                <Table.Row>
                  <Table.Cell content="Employer Name" />
                  <Table.Cell content={person.employer_name} />
                </Table.Row>
                <Table.Row>
                  <Table.Cell content="Employer Phone" />
                  <Table.Cell content={person.employer_phone} />
                </Table.Row>
                <Table.Row>
                  <Table.Cell content="Employer Address" />
                  <Table.Cell content={
                    `${person.employer_address_1} ${person.employer_address_2 ? person.employer_address_2 : ''} ${person.employer_city}, ${person.employer_state} ${person.employer_zip}`
                  }/>
                </Table.Row>
                {references}
              </Table.Body>
            </Table>
          </Item.Description>
        </Item.Content>
      </Item>
    );
  };

  return (
    <Tab.Pane>
      <Item.Group>
        {renterReviewTable(renter)}
        {
          coRenter
            ? renterReviewTable(coRenter)
            : null
        }
      </Item.Group>
    </Tab.Pane>
  );
}
